import { render } from "./opTableServerSide.vue?vue&type=template&id=0d0a701a&ts=true"
import script from "./opTableServerSide.vue?vue&type=script&lang=ts"
export * from "./opTableServerSide.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__